import { CHARGE_TYPE } from '@woovi/shared';

import { PLUGIN_TYPE } from '../../PluginType.ts';
import type { OpenPixCustomer } from '../openPixState.tsx';
import { getOpenPixState } from '../openPixState.tsx';
import type { AdditionalInfoItem } from '../OpenPixStore.tsx';
import { store } from '../OpenPixStore.tsx';

type ChargePayPayload = {
  value: number;
  correlationID: string;
  description: string;
  customer: OpenPixCustomer;
  closeOnSuccess: boolean;
  additionalInfo: AdditionalInfoItem[];
  identifier: string;
  expiresIn: number;
  enableCashbackPercentage?: boolean;
  enableCashbackExclusivePercentage?: boolean;
  customerRegister?: boolean;
  type?: string;
  modal?: boolean;
  splits?: Record<string, unknown>[];
  availablePaymentMethods?: string[];
};
/**
 * $openpix.push([
 *  "pix",
 *  {
 *    value: 100,
 *    correlationID: 'correlationID',
 *    description: 'pay me',
 *    customer: {},
 *    closeOnSuccess: true
 * })
 */
export const chargePay = (args: ChargePayPayload): void => {
  const {
    type = CHARGE_TYPE.DYNAMIC,
    value,
    correlationID,
    description,
    customer,
    closeOnSuccess,
    additionalInfo,
    expiresIn,
    enableCashbackPercentage = true,
    enableCashbackExclusivePercentage = true,
    modal = true,
    customerRegister = false,
    splits,
    availablePaymentMethods,
  } = args;

  const openPixState = getOpenPixState();

  const getCustomer = (): { customer?: OpenPixCustomer } => {
    if (customer) {
      return {
        customer,
      };
    }

    return {};
  };

  const getSplits = (): { splits?: Record<string, unknown>[] } => {
    if (splits) {
      return {
        splits,
      };
    }

    return {};
  };

  const getAvailablePaymentMethods = (): {
    availablePaymentMethods?: string[];
  } => {
    if (!availablePaymentMethods?.length) {
      return {};
    }

    return { availablePaymentMethods };
  };

  store.setState({
    isOpen: true,
    value,
    description,
    correlationID,
    config: openPixState.config,
    success: false,
    closeOnSuccess,
    additionalInfo,
    expiresIn,
    isTemp: false,
    pluginType: PLUGIN_TYPE.PAYMENT,
    enableCashbackPercentage,
    enableCashbackExclusivePercentage,
    modal,
    type,
    customerRegister,
    ...getCustomer(),
    ...getSplits(),
    ...getAvailablePaymentMethods(),
  });
};
